import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import AuthenticMexicanFlavors from "./sections/AuthenticMexicanFlavors";
import ElSaborDeOrzuna from "./sections/ElSaborDeOrzuna";
import OurFamilyHeritage from "./sections/OurFamilyHeritage";
import IndyServiceCircle from "./sections/IndyServiceCircle";
import CelebrationPlanningFaq from "./sections/CelebrationPlanningFaq";
import BeginYourCelebration from "./sections/BeginYourCelebration";
import Gallery from "./sections/Gallery";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <AuthenticMexicanFlavors />
      <IndyServiceCircle />
      <ElSaborDeOrzuna />
      <OurFamilyHeritage />
      <Gallery />
      <CelebrationPlanningFaq />
      <BeginYourCelebration />
      <Footer />
    </div>;
}